/* tslint:disable */
import {
  CompanyAccount
} from '../index';

declare var Object: any;
export interface PropertyEventsInterface {
  "event_type": string;
  "details": string;
  "people"?: string;
  "unit"?: string;
  "updated_by"?: string;
  "id"?: number;
  "property_id"?: number;
  property?: CompanyAccount;
}

export class PropertyEvents implements PropertyEventsInterface {
  "event_type": string;
  "details": string;
  "people": string;
  "unit": string;
  "updated_by": string;
  "id": number;
  "property_id": number;
  property: CompanyAccount;
  constructor(data?: PropertyEventsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyEvents`.
   */
  public static getModelName() {
    return "PropertyEvents";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyEvents for dynamic purposes.
  **/
  public static factory(data: PropertyEventsInterface): PropertyEvents{
    return new PropertyEvents(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyEvents',
      plural: 'PropertyEvents',
      path: 'PropertyEvents',
      idName: 'id',
      properties: {
        "event_type": {
          name: 'event_type',
          type: 'string'
        },
        "details": {
          name: 'details',
          type: 'string'
        },
        "people": {
          name: 'people',
          type: 'string'
        },
        "unit": {
          name: 'unit',
          type: 'string'
        },
        "updated_by": {
          name: 'updated_by',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
      }
    }
  }
}
